import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

const footerSections = [
  {
    label: "Session Controls",
    description: "New, reset, abort, agent switch, model switch, and typed session patch actions.",
  },
  {
    label: "Display Toggles",
    description: "Show thinking, expand tools, and operator-friendly status explanations.",
  },
  {
    label: "Runtime Summary",
    description: "Connection state, activity state, token usage, and gateway status surfaces.",
  },
  {
    label: "Shared Primitives",
    description: "Thread, session rail, assets panel, and task panel reused without leaking operator controls into user chat.",
  },
];

export function OperatorConsoleFooter() {
  return (
    <Card>
      <CardHeader className="border-b border-border">
        <CardTitle>Implementation Spine</CardTitle>
        <CardDescription>
          These are the major slices this scaffold is reserving for the full operator-console build-out.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-3 pt-4 md:grid-cols-2 xl:grid-cols-4">
        {footerSections.map((section) => (
          <div
            key={section.label}
            className="rounded-md border p-3"
            style={{ borderColor: "var(--border)", background: "var(--bg-elevated)" }}
          >
            <div className="text-sm font-medium" style={{ color: "var(--text-strong)" }}>
              {section.label}
            </div>
            <div className="mt-1 text-xs leading-5" style={{ color: "var(--muted-foreground)" }}>
              {section.description}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
